import { type RootState } from '@/store';

export const tokenSelector = (state: RootState) => state.auth.jwtToken;
export const userSelector = (state: RootState) => state.auth.user;
export const userPermissionsSelector = (state: RootState) => state.auth.permissions;
